import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { releasesAPI } from '../services/api';
import '../styles/landing.css';

function ReleaseDetail() {
  const { id } = useParams();
  const [release, setRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadRelease();
  }, [id]);

  const loadRelease = async () => {
    try {
      const response = await releasesAPI.getById(id);
      setRelease(response.data);
    } catch (error) {
      console.error('Error loading release:', error);
      setError('Release not found');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="landing-page">
        <div className="container" style={{ paddingTop: '100px', minHeight: '80vh' }}>
          <p style={{ color: '#a0a0a0', textAlign: 'center' }}>Loading release...</p>
        </div>
      </div>
    );
  }

  if (error || !release) {
    return (
      <div className="landing-page">
        <div className="container" style={{ paddingTop: '100px', minHeight: '80vh', textAlign: 'center' }}>
          <h1 className="section-title" style={{ marginBottom: '20px' }}>Release Not Found</h1>
          <p style={{ color: '#a0a0a0', marginBottom: '30px' }}>{error || 'The release you are looking for does not exist.'}</p>
          <Link to="/releases" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to All Releases
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <div className="container" style={{ paddingTop: '100px', paddingBottom: '80px', maxWidth: '900px' }}>
        <div style={{ marginBottom: '40px' }}>
          <Link to="/releases" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1rem' }}>
            ← Back to All Releases
          </Link>
        </div>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 2fr', 
          gap: '40px',
          marginBottom: '40px',
          alignItems: 'start'
        }}>
          <div>
            <div 
              className="release-image-placeholder"
              style={release.image ? {
                backgroundImage: `url(${release.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                aspectRatio: '1',
                borderRadius: '8px'
              } : {
                width: '100%',
                aspectRatio: '1',
                borderRadius: '8px'
              }}
            ></div>
          </div>
          
          <div>
            <h1 className="section-title" style={{ 
              fontSize: '2.5rem', 
              marginBottom: '20px',
              color: '#228b22',
              fontFamily: 'Bungee, cursive'
            }}>
              {release.title}
            </h1>
            <h2 style={{ 
              fontSize: '1.8rem', 
              marginBottom: '30px',
              fontFamily: 'Bungee, cursive',
              color: '#fff'
            }}>
              {release.artist}
            </h2>
            <div style={{ 
              color: '#a0a0a0', 
              lineHeight: '1.8',
              fontSize: '1.1rem',
              whiteSpace: 'pre-wrap'
            }}>
              {release.description}
            </div>
            {release.createdAt && (
              <p style={{ 
                marginTop: '30px', 
                color: '#666', 
                fontSize: '0.9rem',
                fontStyle: 'italic'
              }}>
                Released: {new Date(release.createdAt).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            )}
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '60px' }}>
          <Link to="/" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ReleaseDetail;

